import * as React from "react";
import { forwardRef } from "react";
const SvgNav = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 43, height: 26, viewBox: "0 0 43 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.86352e-06 8L43 8", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M1.86352e-06 18L43 18", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgNav);
export { ForwardRef as ReactComponent };
